import NavigationCategories from "components/Navigation/NavigationCategories"
import React, { Component, Fragment } from "react"
import FilterContainer from "components/Filter/FilterContainer"
// import {Link, IndexLink} from 'react-router-dom'
import { Header, Table } from "semantic-ui-react"
import shop from "shop/shop"
import app from "app.controller"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import "components/Navigation/NavigationSidebar.scss"
import productStore from "stores/productStore"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import Responsive from "react-responsive"
import MediaQuery from "react-responsive"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import CartButton                                                from "components/Cart/CartButton"
import searchStore                 from "stores/searchStore"
import settingStore from "stores/settingStore"
import languageStore               from "stores/languageStore"

@observer
export default class NavigationSidebar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			categoryData: [],
			isClosed: true
		}
	}

	componentDidMount() {
		shop.events.loaded.add(this.onLoad)
	}

	onLoad = () => {
		this.setState({
			categoryData: shop.categories,
			isClosed: false
		})
	}

	componentWillUnmount() {
		shop.events.loaded.remove(this.onLoad)
	}

	close = () => {
		app.sidebarLeft.close.dispatch()
		this.setState({ isClosed: true })
	}

	render() {
		// const { hasFilter } = categoryStore
		const {showTitle = true} = this.props
		let categoryData         = categoryStore.categories
		const {currentCategory}  = productStore
		const {categoryId}       = currentCategory
		const category           = categoryStore.categoriesById.get(categoryId)
		const {hash} = categoryStore
		const { currentLanguage } = languageStore
		
		if(this.state.isClosed) {
			return null

		}
		return (
			<Fragment>
				<MediaQuery minWidth={768}>
				<nav className="nav NavigationSidebar nav-sidebar pb4 h-100 overflow-y-auto overflow-x-auto" style={{backgroundColor: "#ffffff"}}>
				<FilterContainer category={category} query={this.props.query}/>
				<div className="mb6 limited-height NavigationMenuVertical" style={{backgroundColor: "#ffffff"}}>
					{showTitle && <Header as="h3">{translate("Kategorien")}</Header>}
					<NavigationCategories key={hash} categories={categoryData} />

				</div>
			</nav>
					</MediaQuery>
				<MediaQuery maxWidth={767}>
				<nav className="nav NavigationSidebar nav-sidebar pb4 h-100 overflow-y-auto overflow-x-auto" style={{backgroundColor: "#ffffff"}}>
				<FilterContainer category={category} query={this.props.query}/>
				<div className="mb6 limited-height NavigationMenuVertical">
					{showTitle && <Header as="h3">{translate("Kategorien")}</Header>}

					<NavigationCategories key={hash} categories={categoryData} />

					
					<div className="navigationSidebarUserLinks">
					<div className="flex flex-column items-center justify-center pa3 pl4 pr0">
					{((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) && 
					<Button style={{width: "320px"}} as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Bestandskunden: Anmelden" )}</Button>}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
					<Button style={{width: "320px"}} as={Link} to={`/logout/?referrer=${document.location.pathname}`} primary>{translate( "Abmelden" )}</Button>}
					</div>

					{/*					<table className="w-100 pa3 pl4">
						<colgroup>
							<col width="50%"/>
							<col width="50%"/>
						</colgroup>
						<tbody>
						<tr>
							<td className="tc pt3 pr3">

							</td>
							<td className="tc pt3 pl3">

							</td>
						</tr>
						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr>
							<td className="tc pt3 pr3">

							</td>
							<td className="tc pt3 pl3">
	
							</td>
						</tr>}
						</tbody>	
					</table> */}
					</div>

				</div>
			</nav>
					</MediaQuery>
			</Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Navigation/NavigationSidebar.js